import { CircularProgress } from '@mui/material';
import Box from '@mui/material/Box';
import { SystemStyleObject } from '@mui/system/styleFunctionSx/styleFunctionSx';
import React from 'react';

export const RouteSuspenseFallback: React.FC = (): React.ReactElement => (
  <Box sx={styles.container}>
    <CircularProgress size={64} thickness={5} />
  </Box>
);

const styles: Record<string, SystemStyleObject> = {
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
  },
};
